module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAAAAAA+i0toAAAAAnRSTlMA/1uRIrUAAAAMSURBVHheY7j1/z8ABY8C2UtBe8oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dot.png
// module id = 901
// module chunks = 3